import { render, staticRenderFns } from "./viewBigImage.vue?vue&type=template&id=2077a56e&scoped=true&"
import script from "./viewBigImage.vue?vue&type=script&lang=js&"
export * from "./viewBigImage.vue?vue&type=script&lang=js&"
import style0 from "./viewBigImage.vue?vue&type=style&index=0&id=2077a56e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2077a56e",
  null
  
)

export default component.exports